<template>
    <main-content v-if="current_user.id">
        <manage-settings v-if="$can('change-settings', 'open-banking')"></manage-settings>
        <common-settings v-else></common-settings>
    </main-content>
</template>

<script>


import mainContent from '@/components/main-content'
import manageSettings from './manage-settings'
import commonSettings from './common-settings'
import {mapGetters} from "vuex";

export default {
    components: {
        'main-content': mainContent,
        'manage-settings': manageSettings,
        'common-settings': commonSettings,

    },
    computed :{
        ...mapGetters('user', [
            'current_user'
        ]),
    }

}
</script>

<style>

</style>